// Dugout new-drawing init params. Dugout's host (Moodle `index.php`) puts these on the iframe URL as
// query params (`$_GET`) and, in the original tool, exposes them as `window.*` globals; here the
// standalone tool reads them straight off its own query string. Consumed only behind the dugout gate.
// Placement uses voetbalvorm / formatie* / pitchType (Phase 4); the messaging params (parentUrl /
// userid / questionid / attemptid) are parsed here but wired into the postMessage dialect in Phase 5.

export interface DugoutInitParams {
  userid: string | null;
  questionid: string | null;
  attemptid: string | null;
  parentUrl: string | null;
  voetbalvorm: string | null;
  formatieEigenTeam: string | null;
  formatieTegenstander: string | null;
  pitchType: string | null;
  iconType: string | null;
}

const readDugoutParams = (): DugoutInitParams => {
  const params =
    typeof window === 'undefined'
      ? new URLSearchParams()
      : new URLSearchParams(window.location.search);

  return {
    userid: params.get('userid'),
    questionid: params.get('questionid'),
    attemptid: params.get('attemptid'),
    // underscore spelling — matches the Dugout host's `parent_url` GET param verbatim
    parentUrl: params.get('parent_url'),
    voetbalvorm: params.get('voetbalvorm'),
    formatieEigenTeam: params.get('formatieEigenTeam'),
    formatieTegenstander: params.get('formatieTegenstander'),
    pitchType: params.get('pitchType'),
    // Optional host-driven shape mode ('defaultIcon' | 'alternateIcon'). The tool has no in-tool
    // toggle, so a host that wants a new drawing to start in symbols passes ?iconType=alternateIcon;
    // absent → the DUGOUT_DEFAULT_ICON_TYPE default wins. An imported drawing's own iconType still wins.
    iconType: params.get('iconType'),
  };
};

export default readDugoutParams;
